import React, { useEffect, useState } from 'react';
import Row from '@tcp/core/src/components/common/atoms/Row';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import { bool, string, shape } from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { isClient } from '@tcp/core/src/utils';
import style, { RecommendationCol, CarouselSkeletonView } from '../styles/Recommendations.style';

// eslint-disable-next-line sonarjs/cognitive-complexity, complexity
const RecommendationsSkeleton = (props) => {
  const {
    showPeek,
    newRecommendationEnabled,
    isNewPDPEnabled,
    outOfStock,
    isSNJEnabled,
    searchNoResultRecommendation,
    isNoResponseRecommendation,
    variations,
    className,
    isBagPage,
    cartItemsCount,
    isHomePage,
    isOutFitPage,
    isPDP,
  } = props;
  const isMainView = isHomePage || isOutFitPage || isPDP;
  const [isEmptyBag, setIsEmptyBag] = useState(false);
  useEffect(() => {
    if (isBagPage) {
      const isEmptyBagCheck = !(cartItemsCount && cartItemsCount > 0) && isClient();
      setIsEmptyBag(isEmptyBagCheck);
    }
  }, [cartItemsCount, isClient()]);
  let productSkeleton = isBagPage ? [1, 2, 3, 4, 5, 6] : [1, 2, 3, 4, 5];
  productSkeleton = isEmptyBag ? [1, 2, 3, 4] : productSkeleton;
  productSkeleton = isMainView ? [1, 2, 3, 4, 5, 6] : productSkeleton;

  return (
    <div className={`recommendation-container `}>
      <section className={`${className} recommendations-tile `}>
        <CarouselSkeletonView
          {...props}
          isEmptyBag={isEmptyBag}
          isMainView={isMainView}
          className={`${
            (isNewPDPEnabled && !outOfStock) ||
            (isNewPDPEnabled && isSNJEnabled) ||
            searchNoResultRecommendation ||
            isNoResponseRecommendation
              ? 'recommendations-container-new'
              : 'recommendations-container'
          }${searchNoResultRecommendation ? 'search-no-result-recommendations' : ''} ${
            isMainView ? 'recommendations-container-home' : ''
          }`}
        >
          <div
            className={`${
              isBagPage || isMainView ? 'recommendations-header' : 'accordion-recommendation'
            } ${isMainView ? 'header-skeleton' : ''}`}
          >
            <LoaderSkelton width="145px" height="16px" />
          </div>
          <Row
            fullBleed
            className={`recommendations-section-row ${
              isNewPDPEnabled && isSNJEnabled ? 'recommendation-hide-border' : ''
            }`}
          >
            <RecommendationCol
              showPeek={showPeek}
              newRecommendationEnabled={newRecommendationEnabled}
              className={`recommendations-section-col ${
                isMainView ? 'recommendations-section-home' : ''
              }`}
              colSize={{
                small: 6,
                medium: 8,
                large: 10,
              }}
              offsetLeft={{
                small: 0,
                medium: 0,
                large: 1,
              }}
            >
              <div className={`${variations}-variation carousel-skeleton`}>
                {productSkeleton.map((item) => {
                  return (
                    <div className={`recommendation-item-container item${-item}`} key={item}>
                      <div className="recommendation-itemBox">
                        <div className="carousel-item-image">
                          <LoaderSkelton />
                        </div>
                        <div className="carousel-item-details">
                          <LoaderSkelton />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </RecommendationCol>
          </Row>
        </CarouselSkeletonView>
      </section>
    </div>
  );
};
RecommendationsSkeleton.propTypes = {
  className: string.isRequired,
  variations: string,
  showPeek: shape({}),
  newRecommendationEnabled: bool,
  outOfStock: bool,
  isNewPDPEnabled: bool,
  isSNJEnabled: bool,
  isNoResponseRecommendation: bool,
  searchNoResultRecommendation: string,
  isBagPage: bool,
};

RecommendationsSkeleton.defaultProps = {
  variations: 'moduleO',
  showPeek: { small: false, medium: false },
  newRecommendationEnabled: false,
  outOfStock: false,
  isNewPDPEnabled: true,
  isSNJEnabled: false,
  isNoResponseRecommendation: false,
  searchNoResultRecommendation: '',
  isBagPage: false,
};

export { RecommendationsSkeleton as RecommendationsSkeletonVanilla };

export default withStyles(RecommendationsSkeleton, style);
